import { motion } from 'framer-motion';
import React, { cloneElement, useRef, useState } from 'react';
import { MdArrowOutward } from 'react-icons/md';
import useRem from '../../hooks/useRem';
import Icon from '../ReactIcon';
import { CardImageWrapper } from './styles';

interface CardImageProps {
    src: string;
    text: string;
    description: string;
    icon: JSX.Element;
    onClick: () => void;
    className?: string;
}

export const CardImage: React.FC<CardImageProps> = ({
    src,
    text,
    description,
    icon,
    onClick,
    className,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const descriptionRef = useRef<HTMLDivElement>(null);

    const rem = useRem();
    const descriptionHeight = descriptionRef.current?.clientHeight || 0;

    return (
        <CardImageWrapper
            src={src}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={className}
        >
            <motion.div
                className="containerIconText"
                animate={{
                    y: isHovered ? -(descriptionHeight + 0.5 * rem) : 0,
                }}
                transition={{ duration: 0.15, ease: 'easeInOut' }}
            >
                {cloneElement(icon, { height: '2rem', width: '2rem' })}
                <span>{text}</span>
            </motion.div>

            <motion.div
                className="description"
                initial={{ opacity: 0 }}
                animate={{
                    opacity: isHovered ? 1 : 0,
                    y: isHovered ? 0 : descriptionHeight,
                }}
                ref={descriptionRef}
                transition={{ duration: 0.2, ease: 'easeInOut' }}
            >
                <span>{description}</span>
                <div>
                    <span>Comprar tickets</span>
                    <Icon
                        Icon={MdArrowOutward}
                        height={'2rem'}
                        width={'2rem'}
                    />
                </div>
            </motion.div>
        </CardImageWrapper>
    );
};
